import React from "react";
import Typography from "../Typography";
import { RiTimeLine } from "react-icons/ri";

const ComingSoon = ({ title, icon: Icon }) => {
  return (
    <div className="w-full">
      <div className="w-full mt-3"></div>

      <div className="flex flex-col items-center justify-center min-h-[60vh] py-12 px-4">
        <div className="text-center max-w-md">
          {Icon && (
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center">
                <Icon className="text-4xl text-gray-400" />
              </div>
            </div>
          )}

          <Typography variant="h2" className="text-3xl sm:text-4xl font-bold text-gray-800 mb-4">
            {title}
          </Typography>

          <div className="flex items-center justify-center gap-2 mb-6">
            <RiTimeLine className="text-2xl text-gray-400" />
            <Typography variant="text1" className="text-lg text-gray-600">
              Coming Soon
            </Typography>
          </div>

          <Typography variant="text2" className="text-gray-500 text-sm sm:text-base">
            We're working hard to bring you this feature. Please check back soon!
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
